module.exports = __webpack_public_path__ + "img/zb.aa869b54.png";